import { inject, Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router'
import { AuthService } from '../services/auth.service'

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  private router: Router = inject(Router)
  private authService: AuthService = inject(AuthService)

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    if (!this.authService.isSigned) {
      this.router.navigate(['/auth']).then(() => {})
      return false
    }
    return true
  }
}
